import React from 'react';
import ContactForm from './ContactForm';

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden py-14 sm:py-20">
      {/* Decorative blobs */}
      <div className="pointer-events-none absolute -right-40 -top-20 h-[32rem] w-[32rem] rounded-full bg-[#f2643f]/12 blur-[90px]" />
      <div className="pointer-events-none absolute -left-40 bottom-0 h-[32rem] w-[32rem] rounded-full bg-[#3182ce]/12 blur-[90px]" />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-14">

          {/* ── Left: Text content ── */}
          <div>
            <span className="inline-flex items-center rounded-full border border-[#f6c7b4] bg-[#fff1e8] px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-[var(--brand-accent)]">
              Online cancellation service
            </span>

            <h2 className="mt-6 max-w-2xl text-3xl font-semibold leading-tight tracking-tight text-[var(--brand-deep)] sm:text-4xl lg:text-5xl">
              CANCEL YOUR SUBSCRIPTION FREE AND IMMEDIATELY THROUGH OUR ONLINE<br />CANCELLATION SERVICE.
            </h2>

            <p className="mt-5 max-w-xl text-base leading-relaxed text-[var(--text-muted)] sm:text-lg">
              Our operators are trained by our partners to answer all your questions quickly and efficiently.
            </p>

      
          </div>

          {/* ── Right: Floating preview card ── */}
          <div className="flex justify-center lg:justify-end">
            <div className="w-full max-w-[460px]">
              <ContactForm />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
